module.exports = "/_next/static/images/bdfa363e2fbf622c590844a37cc313c8-website-thumb.jpg.webp";